import type { IssueStatus } from '@/api/client';

// How an issue's state reads on screen, and which tab holds it: Needs eyes gathers what needs eyes (open, regressed,
// acknowledged), the others what does not.
export const STATUS_LABEL: Readonly<Record<IssueStatus, string>> = {
    open: 'Open',
    regressed: 'Regressed',
    acknowledged: 'Acknowledged',
    resolved: 'Resolved',
    muted: 'Muted',
};

export type IssueTab = 'open' | 'resolved' | 'muted' | 'all';

export const TABS: ReadonlyArray<[IssueTab, string]> = [
    ['open', 'Needs eyes'],
    ['resolved', 'Resolved'],
    ['muted', 'Muted'],
    ['all', 'All'],
];

export function inTab(status: IssueStatus, tab: IssueTab): boolean {
    if (tab === 'all') {
        return true;
    }
    if (tab === 'open') {
        return status === 'open' || status === 'regressed' || status === 'acknowledged';
    }

    return status === tab;
}

export const ISSUE_RANGES: ReadonlyArray<[string, string, number]> = [
    ['1h', '1h', 3600_000],
    ['24h', '24h', 24 * 3600_000],
    ['7d', '7d', 7 * 24 * 3600_000],
    ['30d', '30d', 30 * 24 * 3600_000],
];
